export default __webpack_public_path__ + "static/media/NNL_logo.3a5104b3.png";